import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Cliente } from './cliente.model';
import { BackendService } from '../core/backend.service';

@Injectable()
export class ClienteResolver implements Resolve<Cliente> {
  constructor(
    protected router: Router,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        const cliente = this.backendService.new(Cliente);
        return cliente;
      }

      return await this.backendService.get(Cliente, Cliente.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/clientes']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/cliente.resolver.ts